import { getTranslation } from "@/utils";
import styles from "./CollapseTreeButton.module.scss";
import { BareButton } from "@/components";
import { COLLAPSE_TREE_BUTTON_TESTID } from "@/constants/test-ids";

interface CollapseTreeButtonProps {
  isDisabled: boolean;
  handleCollapseTree: () => void;
}

export const CollapseTreeButton = ({
  isDisabled,
  handleCollapseTree,
}: CollapseTreeButtonProps) => {
  return (
    <BareButton
      className={`${styles.collapseAll} ${isDisabled ? styles.disabled : styles.enabled}`}
      handleClick={handleCollapseTree}
      dataTestId={COLLAPSE_TREE_BUTTON_TESTID}
      disabled={isDisabled}
    >
      {getTranslation("filters-tree.button.collapse", "Collapse")}
    </BareButton>
  );
};
